import { render, staticRenderFns } from "./RemoteThresholdData.vue?vue&type=template&id=065697e0&scoped=true"
import script from "./RemoteThresholdData.vue?vue&type=script&lang=js"
export * from "./RemoteThresholdData.vue?vue&type=script&lang=js"
import style0 from "./RemoteThresholdData.vue?vue&type=style&index=0&id=065697e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065697e0",
  null
  
)

export default component.exports